import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import type { AutomationMaster, ClientById, CustomAutomationData, PaymentGatewatMaster, PlanAddons, PosDeviceDetails, PosTerminal, StaffNotificationResponse } from '@fitness-force/models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteStateService {
  private router = inject(Router);


  private currentRoute: string;
  private addonList = new BehaviorSubject<PlanAddons[]>([]);
  paymentGatewayList = new BehaviorSubject<PaymentGatewatMaster[]>([]);
  private deviceList = new BehaviorSubject<PosTerminal[]>([]);
  private client = new BehaviorSubject<ClientById | null>({} as ClientById);
  private tenantId = new BehaviorSubject<number>(0);
  private AutomatiobnEventTenantId = new BehaviorSubject<number>(0);
  private planId = new BehaviorSubject<number>(0);
  private automationData = new BehaviorSubject<CustomAutomationData | null>(null);
  private automationMasters = new BehaviorSubject<AutomationMaster[]>([]);
  private automationEvent = new BehaviorSubject<string>("");
  private closeOmniSearchSidebarAll = new BehaviorSubject<boolean>(false);
  closeOmniSearchSidebarAll$ = this.closeOmniSearchSidebarAll.asObservable();


  private closeSidebar = new BehaviorSubject<boolean>(false);
  closeSidebar$ = this.closeSidebar.asObservable();

  private openClientSidebarById = new BehaviorSubject<number>(0);
  openClientSidebarById$ = this.openClientSidebarById.asObservable();

  private staffNotifications = new BehaviorSubject<StaffNotificationResponse[]>([]);
  staffNotifications$ = this.staffNotifications.asObservable();

  private reloadListPage = new BehaviorSubject<{pageName: string, event: boolean} | null>(null);
  reloadListPage$ = this.reloadListPage.asObservable();

  saveCurrentRoute() {
    this.currentRoute = this.router.url;
  }

  getCurrentRoute() {
    return this.currentRoute;
  }

  redirectToSavedRoute() {
    if (this.currentRoute) {
      this.router.navigateByUrl(this.currentRoute);
    }
  }

  setAddonList(addonList:PlanAddons[]) {
    this.addonList.next(addonList);
  }

  getAddonList() {
    return this.addonList.getValue();
  }

  setAutomationMasters(automationMasters:AutomationMaster[]) {
    this.automationMasters.next(automationMasters);
  }

  getAutomationMasters() {
    return this.automationMasters.getValue();
  }

  getTenantId()
  {
    return this.tenantId.value;
  }

  setTenantTd(tenantId:number)
  {
    this.tenantId.next(tenantId);
  }

  getAutomationTenantId()
  {
    return this.AutomatiobnEventTenantId.value;
  }

  setAutomationTenantId(tenantId:number)
  {
    this.AutomatiobnEventTenantId.next(tenantId);
  }

  getPlanId()
  {
    return this.planId.value;
  }

  setPlanTd(planId:number)
  {
    this.planId.next(planId);
  }

  setPaymentGatewayList(paymentGateway:PaymentGatewatMaster[]) {
    this.paymentGatewayList.next(paymentGateway);
  }

  getPaymentGatewayList() {
    return this.paymentGatewayList.getValue();
  }

  setDeviceList(deviceList:PosTerminal[]) {
    this.deviceList.next(deviceList);
  }

  getDeviceList() {
    return this.deviceList.getValue();
  }

  setClient(client:ClientById | null)
  {
    this.client.next(client);
  }

  getClient():ClientById | null
  {
   return this.client.getValue();
  }

  setAutomationData(automationData:CustomAutomationData | null)
  {
    this.automationData.next(automationData);
  }

  getAutomationData():CustomAutomationData | null
  {
   return this.automationData.getValue();
  }

  setAutomationEventType(automationEvent:string)
  {
    this.automationEvent.next(automationEvent);
  }

  getAutomationEventType():string
  {
   return this.automationEvent.getValue();
  }

  closeClientSidebar(value:boolean) {
    return this.closeSidebar.next(value);
  }

  setClientSidebarById(clientId:number) {
    return this.openClientSidebarById.next(clientId);
  }

  setStaffNotifications(staffNotifications:StaffNotificationResponse[]) {
    this.staffNotifications.next(staffNotifications);
  }

  setReloadListPage(pageName: string, event: boolean) {
    this.reloadListPage.next({pageName, event});
  }

  getReloadListPage() {
    return this.reloadListPage.getValue();
  }

  setCloseOmniSearchSidebarAll(value: boolean) {
    this.closeOmniSearchSidebarAll.next(value);
  }

  getCloseOmniSearchSidebarAll() {
    return this.closeOmniSearchSidebarAll.getValue();
  }
}
